import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconCloseLarge(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M18.707 6.707a1 1 0 0 0-1.414-1.414L12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 1 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
